import React, { lazy } from 'react';
import { Award, Users, ThumbsUp, Clock } from 'lucide-react';
export function TrustBannerSection() {
  const stats = [{
    icon: Users,
    value: '50,000+',
    label: 'Happy Customers'
  }, {
    icon: ThumbsUp,
    value: '4.9/5',
    label: 'Average Rating'
  }, {
    icon: Clock,
    value: '3 Days',
    label: 'Lasting Hold'
  }, {
    icon: Award,
    value: '90 Days',
    label: 'Money-Back Guarantee'
  }];
  return <section className="relative py-16 md:py-20 overflow-hidden" data-id="element-341">
      {/* Background Image */}
      <div className="absolute inset-0" data-id="element-342">
        <img src="https://images.unsplash.com/photo-1517457373958-b7bdd4587205?w=1400&q=80" alt="Warm social gathering" className="w-full h-full object-cover" loading="lazy" data-id="element-343" />
        <div className="absolute inset-0 bg-gradient-to-r from-red-900/90 to-red-800/80" data-id="element-344" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-345">
        <div className="text-center mb-12" data-id="element-346">
          <h2 className="text-3xl md:text-4xl font-bold text-white font-serif mb-3" data-id="element-347">
            Trusted by Thousands. Backed by Science.
          </h2>
          <p className="text-white/80 text-lg max-w-2xl mx-auto" data-id="element-348">
            Dentafix™ has helped over 50,000 denture wearers rediscover
            comfort, confidence, and joy in everyday moments.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8" data-id="element-349">
          {stats.map((stat, index) => <div key={index} className="text-center bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20" data-id="element-350">
              <stat.icon className="w-8 h-8 text-amber-400 mx-auto mb-3" data-id="element-351" />
              <p className="text-3xl md:text-4xl font-bold text-white mb-1" data-id="element-352">
                {stat.value}
              </p>
              <p className="text-white/70 text-sm font-medium" data-id="element-353">{stat.label}</p>
            </div>)}
        </div>
      </div>
    </section>;
}